module.exports = __webpack_public_path__ + "img/pi.1f09100b.png";